import Vue from 'vue';
import AudioRecorder from 'vue-audio-recorder';
import ArgonDashboard from './plugins/argon-dashboard';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import Notifications from 'vue-notification';
import velocity from 'velocity-animate';
import VueSweetalert2 from 'vue-sweetalert2';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Autocomplete from 'vuejs-auto-complete';
import VueSuggestion from 'vue-suggestion';
import Editor from '@tinymce/tinymce-vue';
import VueCookies from 'vue-cookies'
import dateTimePicker from 'vue-bootstrap-datetimepicker';
import $ from 'jquery';
import vSelect from 'vue-select';
import VeeValidate from 'vee-validate';
import VueDictaphone from "vue-dictaphone";
import Dictaphone from '@/components/Dictaphone';

import VueGtag from "vue-gtag";




Vue.use(VueDictaphone);
Vue.use(VueSuggestion);
Vue.use(VueCookies);
Vue.use(VeeValidate);
Vue.use(AudioRecorder);


import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import 'vue-search-select/dist/VueSearchSelect.css';



// Vuex store
import { store } from './store/store';

// Vue router
import router from './router/router';

// Vue i18n
import i18n from './plugins/i18n';

// Vue.$cookies.set('userLanguage',i18n.locale,Infinity,'',window.location.hostname,true);
document.cookie='userLanguage='+i18n.locale+"; expires="+Infinity+";secure;HttpOnly";

// Container component
import App from './App.vue';
import _ from "lodash";
import Swal from "sweetalert2";

// Service worker
//  import './registerServiceWorker';

// Styles


Vue.config.productionTip = false;

// Sweetalert2 options
const options = {
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
};

const Plugin = {
  install(Vue) {
    Vue.component('vue-dictaphone', Dictaphone);
    Vue.component('vue-dictaphone-spectrum-analyser', SpectrumAnalyser);
  },
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Plugin);
}

// Plugins
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import date from "vue-good-table/src/components/types/date";

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(Notifications, { velocity });
Vue.use(VueSweetalert2, options);
Vue.use(ArgonDashboard);
Vue.use(VueAxios, axios);
Vue.use(VueGoodTablePlugin);
Vue.use(dateTimePicker)
Vue.use(VueGtag, { config: { id: "G-SD67Q8D62M", params: {send_page_view: true} }
});

Vue.component('v-select', vSelect)


function debounce(fn, delay = 300) {
	var timeoutID = null;

    return function () {
		clearTimeout(timeoutID);

        var args = arguments;
        var that = this;

        timeoutID = setTimeout(function () {
        	fn.apply(that, args);
        }, delay);
    }
}

// this is where we integrate the v-debounce directive!
// We can add it globally (like now) or locally!
Vue.directive('debounce', (el, binding) => {
	if (binding.value !== binding.oldValue) {
		// window.debounce is our global function what we defined at the very top!
		el.oninput = debounce(ev => {
			el.dispatchEvent(new Event('change'));
		}, parseInt(binding.value) || 300);
	}
});

// Gestion des permissions 

Vue.directive('can', function (el, binding, vnode) {
  let permissions = localStorage.getItem('permissions') ? localStorage.getItem('permissions') : [];
  if(permissions.indexOf(binding.value) !== -1){
     return vnode.elm.hidden = false;
  }else{
     return vnode.elm.hidden = true;
  }
})
// gestion des roles
Vue.directive('is', function (el, binding, vnode) {
  let role = localStorage.getItem('role') ? localStorage.getItem('role') : [];
  if(role == binding.value){
     return vnode.elm.hidden = false;
  }else{
     return vnode.elm.hidden = true;
  }
})

// Components
Vue.component('autocomplete', Autocomplete);

// Navigation guards before each request
router.beforeResolve((to, from, next) => {
  //Nprogress.start();

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // User needs to be logged in
    if (localStorage.getItem('user') == null ) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      const date = localStorage.getItem('token-expires-at');

      let expiryDate = new Date(date);
      let today = new Date();

      if((today > expiryDate)) {
        // If token has expired, logout user
        store.dispatch('logoutHandler', { args: {} });

        next({
          path: '/login',
          query: { redirect: to.fullPath }
        });
      } else {
        // If token is still valid, process request
        next();
      }

      next();
    }
  } else if(to.matched.some(record => record.meta.guest)) {
    if(localStorage.getItem('ms-token') == null){
      next();
    }
    else{
      next({ path: '/dashboard'})
    }
  } else {
  
    let rArray = store.state.requiredConfirmationRoutes.requiredConfirmationRoutes;
    let bArray = store.state.requiredConfirmationRoutes.breadcrumbItems;

    let continuer = true;
        if("-1" != (_.findIndex([{title:'validation'},{title:'medical-management'},{title:'user-management'},{title:'facturations'},{title:'appointments'},{title:'admin-management'},{title:'activite-management'}],{'title':to.name})) ){
            store.dispatch('dropRightItem', {name: to.name });
        }

    if(("-1" != (_.findIndex(rArray,{'title':from.name})) && ("-1" != (_.findIndex(bArray,{'title':to.name})) ))){


      Swal.fire({
        title: i18n.t('message.areYouSure'),
        text: i18n.t('message.unsaveData'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00ada7',
        cancelButtonColor: '#f5365c',
        cancelButtonText: i18n.t('message.cancel'),
        confirmButtonText: i18n.t('message.yesLeave')
      }).then((result) => {
        if (result.value) {
          let routeExiste =  _.find(bArray,function (item) {
            return item.title == to.name
          });
          if (_.isUndefined(routeExiste)){
            if((to.name).trim() != 'login' && (to.name).trim() != 'landing' && (to.name).trim() != ''){
              let item =
                  {
                    title:to.name,
                    text:to.meta.title,
                    to:to.path,
                  };

              store.dispatch('addItem', {item: item });
            }
          }else{
            store.dispatch('dropRightItem', {name: to.name });
          }
          next();
        }else{
          next(false)
        }
      })
    }else{

      let routeExiste =  _.find(bArray,function (item) {
        return item.title == to.name
      });
      if (_.isUndefined(routeExiste)){
        if((to.name).trim() != 'login' && (to.name).trim() != 'landing' && (to.name).trim() != ''){
          let item =
              {
                title:to.name,
                text:to.meta.title,
                to:to.path,
              };

          store.dispatch('addItem', {item: item });
        }
      }else{
        store.dispatch('dropRightItem', {name: to.name });
      }

      // User doesn't need to be logged in
      next(continuer);
    }
    // next();
  }

});

// Navigation guards after each request
router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  //Nprogress.done();
});

// Using font-awesome 5 icons
// $.extend(true, $.fn.datetimepicker.defaults, {
//   icons: {
//     time: 'far fa-clock',
//     date: 'far fa-calendar',
//     up: 'fas fa-arrow-up',
//     down: 'fas fa-arrow-down',
//     previous: 'fas fa-chevron-left',
//     next: 'fas fa-chevron-right',
//     today: 'fas fa-calendar-check',
//     clear: 'far fa-trash-alt',
//     close: 'far fa-times-circle'
//   }
// });

new Vue({
  router,
  store,
  i18n,
  //messages,
  render: h => h(App)
}).$mount('#app');

